import closest from '@mailobj-browser/front/js/selectors/closest.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { selector } from '../field/main.js'
import { elements, modifiers } from '../styles.js'

const selectors = `${selector}, ${elements.listenable} fieldset`

const options = object(null, {
  attributes: true,
  attributeFilter: array(['disabled']),
  subtree: true
})

export default body => {
  const { ownerDocument } = body

  if (!ownerDocument.contains(body)) {
    return
  }

  queueMicrotask(async () => {
    for await (const { target } of mutations(body, options, removed(body))) {
      const { disabled } = target
      const node = closest(selectors, target)

      if (!node) {
        continue
      }

      if (disabled) {
        node.classList.add(modifiers.field.disabled)
      } else {
        node.classList.remove(modifiers.field.disabled)
      }
    }
  })
}
